// extracted by mini-css-extract-plugin
module.exports = {"container":"Collapsable_container__2BkrW","footer":"Collapsable_footer__1nGjC"};